import axios from "axios";

const module = {
    namespaced: true,
    state: {
        allData: [],
    },
    mutations: {
        setAllAstralCard: (state, info) => state.allData = info,
        updateAstralCard: (state, info) => {
            return state.allData = state.allData.map((item) => {
                if (item.id == info.astral_card.id) {
                    item.file_url = info.astral_card.file_url
                }
                return item
            })
        },
        removeAstralCard: (state, info) => {
            return state.allData = state.allData.map((item) => {
                if (item.id == info.id) {
                    return  
                } else  {
                    return item
                }
            })
        },
        addAstralCard: (state, info) => {
            // info.allData.editableFlag = true
            state.allData.push(info.astral_card)
        },
        setAstralCardUserId: (state, info) => {
            state.allData = info
        }
    },
    actions: {
        async fetchData({commit}) {
            const response = await axios.get('user/astral-card')
            commit('fetchData', response.data)
        },
        async fetchDataAllAstralCard({commit}) {
            const response = await axios.get('admin/astral-card')
            commit('setAllAstralCard', response.data.astral_cards)
        },
        async updateData({commit}, data) {
            return await axios.post(`admin/astral-card/${data.id}`, data.data, {headers: {"Content-Type": "multipart/form-data"}}).then((response) => {
                commit('updateAstralCard', response.data)
                return response
            })
        },
        async removeAstralCard({commit}, data) {
            return await axios.delete(`admin/astral-card/${data.id}`).then((response) => {
                response.id = data.id
                commit('removeAstralCard', response)
                return response
            })
        },
        async addUserAstralCard ({commit}, data) {
            return await axios.post('admin/astral-card', data.data).then((response)=> {
                if (response.data) {
                    response.data.astral_card.email = data.email
                    console.log(response)
                    commit ('addAstralCard', response.data)
                }
                return response
            }).catch((error) => {
                console.log(error)
                return error
            })
        },
        async fetchAstralCardUserId({commit}, data) {
            const response = await axios.get(`admin/astral-card?user_id=${data.id}`)
            commit('setAstralCardUserId', response.data.astral_cards)
        }
    }
}
export default module
